<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox">
        <van-icon
          @click="close"
          class="cross"
          name="cross"
        />
      </div>
      <div class="myPopupContentCenter">
        <PuPdf :urlLink="urlLink" />
      </div>
    </div>
  </div>
</template>
<script>
import PuPdf from '@/components/PDF/index.vue';

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  components: {
    PuPdf,
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
    urlLink: {},
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 6px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.myPopupContentCenter {
  flex: 1;
  overflow: auto;
}
</style>
